const AVATAR_BG_PALETTE = [
  "bg-blue text-white",
  "bg-green text-white",
  "bg-purple text-white",
  "bg-yellow text-white",
  "bg-red text-white",
];

function getAvatarPalette(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++)
    hash = (hash * 31 + id.charCodeAt(i)) | 0;
  return AVATAR_BG_PALETTE[Math.abs(hash) % AVATAR_BG_PALETTE.length];
}

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || parts[0].length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

interface Props {
  id: string;
  name: string;
  avatarUrl?: string | null;
}

function Avatar({ approver }: { approver: Props }) {
  if (approver.avatarUrl)
    return <img className="size-4 rounded-full shrink-0 object-cover border border-gray-100" src={approver.avatarUrl} alt={approver.name} />;
  return (
    <div className={`size-4 rounded-full shrink-0 flex items-center justify-center text-[9px] font-semibold font-gilroy border border-gray-100 ${getAvatarPalette(approver.id)}`}>
      {getInitials(approver.name)}
    </div>
  );
}

export default Avatar;
